import React, { useContext, useEffect, useRef } from "react";
import styles from "./ProgressBar.module.scss";
import PathContext from "../../context/path";
import Counter from '../Counter';
import { useState } from 'react';
const ProgressBar = () => {
  const path = useContext(PathContext);
  const refWrap = useRef(null);
  const [trigger, setTrigger] = useState(false);
  let wrapClass = `${styles.wrap}`;
  useEffect(()=>{
    const wrap = refWrap.current;
      let options = {
        threshold: 1,
        rootMargin: '0% 0% 0% 0%'
      }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.animate);
          setTrigger(true);
          observer.unobserve(entry.target);
        }
      })
    }, options);
    observer.observe(wrap);
    return()=>{
      observer.unobserve(wrap);
    }
  },[]);
  return (
    <>
      <div className={wrapClass} ref={refWrap}>
        <div className={styles.counters}>
          <div className={`${styles.counter}`}>
            <div className={styles.counter__header}>
              <span>
                <Counter start={0} finish={70} duration={1500} floor={true} manual={true} triggered={trigger} />
              </span>
              %
            </div>
            <div className={styles.counter__text}>времени — продаем</div>
          </div>
          <div className={`${styles.counter} ${styles.counter_small}`}>
            <div className={styles.counter__header}>
              <span>
                <Counter start={0} finish={30} duration={1500} floor={true} manual={true} triggered={trigger} />
              </span>
              %
            </div>
            <div className={styles.counter__text}>делаем отчеты</div>
          </div>
        </div>
        <div className={styles.bar}>
          <div className={styles.bar__inner}></div>
        </div>
      </div>
    </>
  );

}

export default ProgressBar;
